import { db } from '@/db/schema';
import { getState, updateState } from '@/db/repositories/localSignState';
import type { Sign } from '@/types/catalog';

export async function isFavorite(signId: string): Promise<boolean> {
  return (await getState(signId)).favorite;
}

export async function setFavorite(signId: string, favorite: boolean): Promise<void> {
  await updateState(signId, (current) => ({ ...current, favorite }));
}

export async function toggleFavorite(signId: string): Promise<boolean> {
  const next = await updateState(signId, (current) => ({ ...current, favorite: !current.favorite }));
  return next.favorite;
}

export async function listFavoriteIds(): Promise<string[]> {
  // Varredura filtrada, não índice: o IndexedDB não indexa boolean (ver schema.ts).
  // `localSignState` só tem linha para sinal que o usuário tocou, então a tabela é
  // menor que o catálogo.
  const rows = await db.localSignState.filter((row) => row.favorite).toArray();
  return rows.map((row) => row.signId);
}

/** Favoritos resolvidos em sinais, na ordem do catálogo. */
export async function listFavoriteSigns(): Promise<Sign[]> {
  const ids = await listFavoriteIds();
  if (ids.length === 0) return [];

  const signs = (await db.signs.bulkGet(ids)).filter((sign): sign is Sign => sign !== undefined);
  return signs.sort(
    (a, b) => a.categoryId.localeCompare(b.categoryId) || a.order - b.order,
  );
}

export async function countFavorites(): Promise<number> {
  return db.localSignState.filter((row) => row.favorite).count();
}
